import React, { Component } from 'react'
import RaisedButton from 'material-ui/RaisedButton'
import ContactForm from './../ContactForm/ContactForm'

class Donate extends Component {

  constructor(props) {
    super(props)

    this._handleClick = this._handleClick.bind(this)

  }

  _handleClick () {
    window.analytics.track('Donation Clicked')
  }

  render () {
    return (
      <div className="donation-page">
        <div className="section-header">
          <h1 className="title">Support Mind Makers</h1>
        </div>
        <div className="section-body">
          <p>Your support will enable us to continue producing our curriculum, and refining and testing our workshop designs, with the ultimate goal of revealing the possibility for tech proficiency in adults from all walks of life. Together, with your help, we will inspire a new wave of stereotype-smashing, modern makers and engineering enthusiasts.</p>
          <br />
          <p>As we pursue a multifaceted mission as an organization with many moving parts, donations of all sizes help us in many ways!</p>
          <p>$30 sponsors one student for a software workshop</p>
          <p>$50 sponsors one student for a hardware workshop</p>
          <p>$1k sponsors all non-reusable resources necessary for an entire 20-person workshop</p>
          <p>$5-10k provides much needed manufacturing equipment, such as laser cutters, 3D printers and more</p>
          <br />
          <p>As a nonprofit and 100% volunteer based organization, Mind Makers relies on donors like you. As a 501(c)3, your support is also completely tax deductible. Please contact <a href="mailto:michelle@mindmakersproject.org">Michelle Easter</a> or <a href="mailto:julie@mindmakersproject.org">Julie Mack Boyce</a> to obtain a donation receipt for tax reporting purposes.</p>
          <div className="donate-form">
            <RaisedButton
              className="donate-button"
              href="https://www.paypal.me/MindMakers"
              target="_blank"
              label="Donate Now"
              onClick={this._handleClick}
              primary={true}
              style={{width: '200px', marginBottom: '25px'}}
            />
          </div>
          <hr className="donate-hr" />
          <div className="sponsor-section">
            <h1>Our Sponsors</h1>
            <div className="sponsor-row">
              <img className="" alt="global aeroleasing" src="https://github.com/MindMakersProject/website-BE/blob/master/icons/global-aeroleasing.png?raw=true" />
              <img className="" alt="supplyframe designlab" src="https://github.com/MindMakersProject/website-BE/blob/master/icons/supplyframe-designlab.png?raw=true" />
              <img className="" alt="william connolly" src="https://github.com/MindMakersProject/website-BE/blob/master/icons/william-connolly.png?raw=true" />
            </div>
            <div className="sponsor-row">
              <img className="" alt="karin herzfeld" src="https://github.com/MindMakersProject/website-BE/blob/master/icons/karin-herzfeld.png?raw=true" />
              <img className="" alt="johnnys" src="https://github.com/MindMakersProject/website-BE/blob/master/icons/johnnys.png?raw=true" />
            </div>
          </div>
          <div className="purple-section">
            <div className="section-body">
              <p>As a nonprofit, Mind Makers, Inc. relies on donors like you to help us increase STEM potential for children and unconventional adults through education, outreach and awesome displays of tech teamwork. As a 501(c)3, your support is also tax deductible.</p>
              <br />
              <p>Mind Makers cares deeply about engaging our community, hosting hands-on workshops, giving talks, mentoring teenagers, and more. We do all of this while building a free and approachable curriculum which teaches fundamentals of robotics while illustrating its parallels with other STEM fields. We aim to educate and activate unconventional, stereotype-breaking tech enthusiasts all over the world to learn, create and propagate.</p>
              <br />
              <p>Mind Makers appreciates your support of our vision to build a diverse, technology proficient community that values knowledge sharing, redefines possibility and inspires a new generation of engineering enthusiasts.</p>
              <br />
              <p>Make a one-time gift or a monthly contribution here. Thank you for your support.</p>
            </div>
              <RaisedButton
                className="donate-button"
                href="https://www.paypal.me/MindMakers"
                target="_blank"
                label="Donate Now"
                onClick={this._handleClick}
                primary={true}
                style={{width: '200px', marginTop: '25px'}}
              />
          </div>
        </div>
        <div>
          <ContactForm formName="Support" />
        </div>
      </div>
    )
  }
}

export default Donate



// WEBPACK FOOTER //
// ./src/components/Donate/Donate.js